// src/pages/NewsDetails.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress, Button, Alert } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReactMarkdown from "react-markdown";
import { useAuth } from "../context/AuthContext";


const NewsDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { authAxios } = useAuth();

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await authAxios.get(`/news/${id}`);
        setItem(res.data);
      } catch {
        setError("Failed to load news details");
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, [id, authAxios]);

  if (loading) {
    return (
      <Box textAlign="center" mt={8}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 4 }}>
        {error}
      </Alert>
    );
  }

  if (!item) {
    return (
      <Typography textAlign="center" mt={8} color="text.secondary">
        News item not found
      </Typography>
    );
  }

  const title = item.title_en || item.title_de || "Untitled";
  const body = item.body_en || item.body_de || "";

  return (
    <Box
  
      sx={{
        maxWidth: "960px",
        mx: "auto",
        py: { xs: 4, md: 5 },
        px: { xs: 2, md: 0 },
        textAlign: "right",
      }}
    >
      {/* Back button */}
      <Button
          variant="contained"
        onClick={() => navigate(-1)}
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 5,
        mt: 3,
             borderRadius: 2,
            boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',

         }}
      >
        Back
      </Button>

      {/* Title – left, primary color */}
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{
          mb: 4,
          textAlign: "left",
          color: "primary.primary",
        }}
      >
        {title}
      </Typography>

      {/* Image – centered, rounded */}
      {item.image_url && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 4,
          }}
        >
          <Box
            component="img"
            src={item.image_url}
            alt={title}
            sx={{
              objectFit: "cover",
              maxWidth: "900px",      
              borderRadius: "16px",
              display: "block",
            }}
          />
        </Box>
      )}

      {/* Text – same width as image area, left aligned */}
      <Box
        sx={{
          maxWidth: "860px",
          mx: "auto",
        }}
      >
        <Typography
          component="div"
          variant="body1"
          sx={{
            fontSize: "1rem",
            lineHeight: 1.8,
            color: "text.grey700",
            textAlign: "left",
          }}
        >
          <ReactMarkdown>{body}</ReactMarkdown>
        </Typography>
      </Box>
    </Box>
  );
};

export default NewsDetails;
